<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 487.17 530.35"
    class="svg-icon relative"
    style="font-size: 0.7em; top: -0.15em;"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="cls-1"
          d="M225,520.21C158.34,407.05,93.67,291.33,28,179.76a20.58,20.58,0,0,1,17.73-31H439.76a20.58,20.58,0,0,1,17.73,31C391.9,291.13,327,407.21,260.45,520.21A20.58,20.58,0,0,1,225,520.21Z"
        />
        <rect class="cls-2" width="487.17" height="62.21" rx="20.69" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "IconSortDecrease"
};
</script>
